export default "__VITE_ASSET__N8hHbrdW__"